import type { H3Event } from 'h3';

export function getClientIdFromEvent(event: H3Event): string {
  const host = getRequestHost(event);
  const query = getQuery(event);
  const queryPlatform = query['platform'] as string;
  const queryCountry = query['country'] as string;
  const [platform, countryCode, multinational] = getPlatformForHost(host, queryPlatform, queryCountry);
  return getClientId(platform, countryCode, multinational);
}

export function getClientId(platformName: string, countryCode: string, multinational: boolean): string {
  const runtimeConfig = useRuntimeConfig();

  let clientId = runtimeConfig.public.BIKEABLE_CH_AUTH_CLIENT_ID as string;

  if (platformName == 'bikeable') {
    if (multinational) {
      clientId = runtimeConfig.public.BIKEABLE_WORLD_AUTH_CLIENT_ID as string;
    } else if (countryCode == 'ch') {
      clientId = runtimeConfig.public.BIKEABLE_CH_AUTH_CLIENT_ID as string;
    } else if (countryCode == 'de') {
      clientId = runtimeConfig.public.BIKEABLE_DE_AUTH_CLIENT_ID as string;
    } else if (countryCode == 'at') {
      clientId = runtimeConfig.public.BIKEABLE_AT_AUTH_CLIENT_ID as string;
    } else if (countryCode == 'us') {
      clientId = runtimeConfig.public.BIKEABLE_US_AUTH_CLIENT_ID as string;
    }
  } else if (platformName == 'walkable') {
    if (multinational) {
      clientId = runtimeConfig.public.WALKABLE_WORLD_AUTH_CLIENT_ID as string;
    } else {
      clientId = runtimeConfig.public.WALKABLE_CH_AUTH_CLIENT_ID as string;
    }
  }

  return clientId;
}

export function getPlatformForHost(host: string, queryPlatform: string, queryCountry: string): [string, string, boolean] {

  const domainName = getDomainNameFromHost(host);
  const domainEnding = getDomainEndingFromHost(host);

  var multinational = false;
  var platformName = 'bikeable';
  var countryCode = 'ch';

  if (domainName === 'bikeablecity') {
    multinational = false;
    platformName = 'bikeable';
    countryCode = 'us';
  } else if (domainName === 'bikeable') {
    platformName = 'bikeable';
    multinational = false;
    countryCode = domainEnding;
  } else if (domainName === 'bikeable-world') {
    platformName = 'bikeable';
    multinational = true;
  } else if (domainName === 'walkable') {
    multinational = false;
    platformName = 'walkable';
    countryCode = 'ch';
  } else if (domainName === 'walkable-world') {
    platformName = 'walkable';
    multinational = true;
  }else {
    // When running locally, you can use the query parameter to set the platform and country
    if (queryPlatform === 'walkable') {
      multinational = false;
      platformName = 'walkable';
    } else {
      multinational = false;
      platformName = 'bikeable';
    }
    if (queryCountry) {
      if (queryCountry === 'world') {
        multinational = true;
      } else {
        countryCode = queryCountry;
      }
    } else {
      countryCode = 'ch';
      multinational = false;
    }
  }

  return [platformName, countryCode, multinational];
}


function getDomainNameFromHost(host: string) {
  const parts = host.split('.');
  if (parts.length === 3) {
    return parts[1];
  } else {
    return parts[0];
  }
}

function getDomainEndingFromHost(host: string) {
  const parts = host.split('.');
  if (parts.length === 3) {
    return parts[2];
  } else {
    return parts[1];
  }
}





